import { render, staticRenderFns } from "./wxsstock-add-or-update.vue?vue&type=template&id=06ae1f0f&"
import script from "./wxsstock-add-or-update.vue?vue&type=script&lang=js&"
export * from "./wxsstock-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports